import { useQuery } from '@tanstack/react-query';
import { StaticsApi } from '@/api/statics';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useGetStatics = () => {
  const { languages } = useSelector((state) => state.entities);

  const currentLanguageId = useMemo(() => {
    if (languages) {
      const lang = localStorage.getItem('language') || 'en';
      const langId = languages.find((i) => i.code === lang.toUpperCase())?.id;

      return langId ?? null;
    }
    return null;
  }, [languages]);

  const { isLoading, isError, data, error, refetch } = useQuery({
    queryKey: ['StaticsApi.getStatics'],
    queryFn: () => StaticsApi.getStatics({ languageId: currentLanguageId }),
    select: (res) => res.data,
    enabled: !!currentLanguageId
  });

  return {
    isLoading,
    isError,
    data,
    error,
    refetch
  };
};
